"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useComputedColor = void 0;
var _react = require("react");
var _useColorUtils2 = require("./useColorUtils");
var useComputedColor = function useComputedColor() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var color = args.color,
    defaultColor = args.defaultColor;
  var _useColorUtils = (0, _useColorUtils2.useColorUtils)(),
    getConstColor = _useColorUtils.getConstColor,
    getThemeColor = _useColorUtils.getThemeColor;
  var isDefaultColorValue = color === 'default';
  var currentColorKey = isDefaultColorValue ? defaultColor : color;
  var themeColor = getThemeColor(currentColorKey);
  var constColor = getConstColor(currentColorKey);
  var computedColor = (0, _react.useMemo)(function () {
    var computed = themeColor || constColor || currentColorKey;
    if (!isDefaultColorValue && !computed) {
      computed = getThemeColor(defaultColor) || getConstColor(defaultColor);
    }
    return computed || defaultColor;
  }, [constColor, currentColorKey, defaultColor, getConstColor, getThemeColor, isDefaultColorValue, themeColor]);
  return {
    currentColorKey: currentColorKey,
    themeColor: themeColor,
    constColor: constColor,
    computedColor: computedColor
  };
};
exports.useComputedColor = useComputedColor;